var _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoDataFound = function SvgNoDataFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 75,
    viewBox: "0 0 81 75",
    width: 81,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1d2130",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 28.4971 23.553-26.4971v25.4971c0 .5523-.4477 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.1055 31.4453 11.7765 11.7765",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.8828 31.4453-11.7765 11.7765",
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m25.553 4h33.3296v16.0956c1.4038.3155 2.7445.7981 4 1.4259v-17.5215c0-2.20913-1.7909-4-4-4h-33.3296zm37.3296 49.1401c-1.2555.6277-2.5962 1.1103-4 1.4258v16.0932h-54.8826v-42.1619h-4v42.1619c0 2.2091 1.79086 4 4 4h54.8826c2.2091 0 4-1.7909 4-4z",
    fill: "#1d2130",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m54.9929 54.9955c9.756 0 17.6648-7.9087 17.6648-17.6647s-7.9088-17.6648-17.6648-17.6648-17.6648 7.9088-17.6648 17.6648 7.9088 17.6647 17.6648 17.6647z",
    stroke: "#1d2130",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m78.546 63.8273-11.7765-11.7765",
    stroke: "#1d2130",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })));
};
export default SvgNoDataFound;